import { styled } from '@mui/material/styles';

const Label = styled('div')`
  color: #949494;
  font-weight: 600;
  text-align: center;
`;
const StyledGridOverlay = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 250px;
  width: 100%;
  background-color:#ffffff;  
`;
interface IGridRowsImageProps {
  label?: string;
}
export const GridRowsImage = ({ label }: IGridRowsImageProps) => (
  <StyledGridOverlay>
    <Label>{label}</Label>
  </StyledGridOverlay>
);
